// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NetworkType } from "@lib/messaging/NetworkType";
import { NetworkSource } from "@lib/messaging/NetworkSource";
import { RpcHub } from "@lib/messaging/rpc/RpcHub";
import { CancellationToken } from "@lib/utilities/CancellationToken";
import { RpcResult } from "./RpcResult";

/**
 * Provides an API for calling remote RPC methods.
 */
export interface IRemoteRpcHub
{
  createClientHub(networkType: NetworkType, cancellationToken: Optional<CancellationToken>): RpcHub;
  createClientHub(networkSource: NetworkSource, cancellationToken: Optional<CancellationToken>): RpcHub;
  invoke<T, E>(target: NetworkSource, method: string, args: any[], timeout?: number): RpcResult<T, E>;
  notify(target: NetworkSource, method: string, args: any[]): void;
}